import { inject } from '@angular/core';
import { SplashScreenStateService } from '../common/services/splash-screen-state.service';
import { ConfigService } from '../config/services/config.service';
import { Router } from '@angular/router';
import { CurafidaAuthService } from '../authentication/curafida-auth.service';

export const RegisterFeatureGuard = () => {
    const router = inject(Router);
    const loggedInUser = inject(CurafidaAuthService).loggedInUser;
    const configService = inject(ConfigService);
    const splashScreenStateService = inject(SplashScreenStateService);

    const isRegistrationEnabled = configService.config()?.configuration?.features?.register?.enabled;
    const isLoggedIn = Boolean(loggedInUser());

    if (!isLoggedIn && isRegistrationEnabled) {
        splashScreenStateService.stop();
        return true;
    } else {
        return router.navigate(['/']);
    }
};
